// Vendors
import React, { useEffect } from 'react';
import { Toolbar, Avatar, Menu, MenuItem, Box } from '@mui/material';
import { oktaAuth } from '@/components/pages/LoginPage/index';
import { store } from '@/store/store';
import { logout } from '@/store/features/auth/authSlice';

// Assets
import logo from '@/assets/logo/assurant-logo.png';
import menuIcon from '../../../assets/icons/menunav-vertical.svg';

// Models & Store
import { AuthState, loginRequest, loginSuccess } from '@/store/features/auth/authSlice';
import { useAppDispatch, useAppSelector } from '@/hooks/storeHook';

/**
 * Component: Header
 * Displays the application header with user authentication and navigation menu.
 */
const Header: React.FC = () => {
  const dispatch = useAppDispatch();
  const userDetails = useAppSelector((state: { auth: AuthState }) => state.auth.user);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const fetchTokenDetails = async () => {
    dispatch(loginRequest());

    const fetchUser = async () => {
      const userValue = await oktaAuth.getUser();
      return userValue;
    };

    const storedToken = localStorage.getItem('auth_token');
    const storedUser = await fetchUser();

    const userObj = {
      id: '0',
      email: storedUser.email as string,
      apv_groups: storedUser['apv.groups'] as string[],
      userClientId: '',
      firstName: storedUser.firstName as string,
      lastName: storedUser.lastName as string,
      lanId: 0,
      username: storedUser.username as string,
      samAccountName: storedUser.samAccountName as string,
    };

    if (storedToken) {
      try {
        dispatch(loginSuccess({ user: userObj, token: storedToken }));
      } catch (error) {
        console.error('Error parsing stored user:', error);
        localStorage.removeItem('auth_user');
      }
    } else {
      console.log('Dispatching loginRequest...');
      dispatch(loginRequest());
    }
  };

  useEffect(() => {
    fetchTokenDetails().catch((err: unknown) => console.log(err));
  }, [dispatch]);

  const handleMenuOpen = (event: React.MouseEvent<HTMLImageElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    store.dispatch(logout());
    setAnchorEl(null);
  };
  const getInitials = (firstName?: string, lastName?: string) => {
    if (!firstName || !lastName) return 'U'; // Default to "U" for "User"
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  };

  return (
    <div className="lnf-header_wrap">
      <div className="header-container">
        <Toolbar className="tool-bar">
          <Box className="left-section">
            <img alt="Logo" src={logo} className="assurant-logo" />
          </Box>
          <Box className="right-section">
            <Avatar sx={{ width: 30, height: 30, mr: 1, bgcolor:"#666666" }}>
              {getInitials(userDetails?.firstName as string, userDetails?.lastName)}
            </Avatar>
            <div className="menu-nav-icon">
              <img src={menuIcon} alt="menu-icon" onClick={handleMenuOpen} />
            </div>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </div>
    </div>
  );
};

export default Header;
